/* eslint-disable @typescript-eslint/no-unsafe-member-access,
    @typescript-eslint/no-unsafe-assignment */
import { Accordion } from 'features/ContactSidebar/Accordion';
import { Box } from 'components/Box';
import { Tag } from 'components/Tag';
import { connect } from 'react-redux';
import { useContext } from 'react';
import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';
import { GeographyOptionResource } from 'util/resources/GeographyOption';

const ContactSidebarMainLocationsComponent = ({
  geographyOptions,
}: {
  geographyOptions: {
    location: GeographyOptionResource[];
  };
}) => {
  const { userProfile, hasPreferences } = useContext(ContactSidebarContext);

  if (!hasPreferences.desiredLocations) {
    return null;
  }

  const desiredLocations = userProfile.desiredLocations(geographyOptions);

  return (
    <Accordion title="Locations">
      <Box>
        <div className="flex justify-start items-start flex-wrap py-2 gap-1.5">
          {desiredLocations.map((loc) => (
            <Tag key={loc?.title}>{loc?.title}</Tag>
          ))}
        </div>
      </Box>
    </Accordion>
  );
};

function mapStateToProps(state) {
  return {
    geographyOptions: state.geographies.geographyOptions,
  };
}

export const ContactSidebarMainLocations = connect(mapStateToProps)(
  ContactSidebarMainLocationsComponent,
);
ContactSidebarMainLocations.displayName = 'ContactSidebarMainLocations';
